import analyticsEventValues from '@/consts/analytics/analyticsEventValues';
import * as sourceTypes from '@/consts/sourceTypes';
import marketService from '@/services/marketService';
import stringUtils from '@/utils/stringUtils';
import uaUtils from '@/utils/uaUtils';
import urlUtils from '@/utils/urlUtils';

export const getPushSource = (source) => {
    switch (source) {
        case sourceTypes.HOMEPAGE:
            return analyticsEventValues.HOMEPAGE;
        case sourceTypes.INBOX:
            return analyticsEventValues.INBOX;
        default:
            return null;
    }
};

export const getDeviceType = () => {
    const deviceType = uaUtils.getDeviceType();

    return stringUtils.capitalize(deviceType);
};

export const getPageId = () => {
    const selectedMarketCode = marketService.getMarketCode();
    const pathname = urlUtils.getCurrentPathname();
    const parts = pathname.split('/');
    const marketIndex = parts.indexOf(selectedMarketCode);

    if (marketIndex !== -1 && marketIndex + 1 < parts.length) {
        return stringUtils.capitalize(parts.slice(marketIndex + 1).join('/'));
    } else {
        return null;
    }
};
